import { ActivityV2 } from 'models/activityV2'
import { BaseEventCard, getActionText } from './BaseEventCard'

interface ReminderEventCardProps {
  event: ActivityV2
}

export function ReminderEventCard({ event }: ReminderEventCardProps) {
  // Get reminder details from field_history_objects
  const titleField = event.field_history_objects?.find(
    (field) => field.field_name === 'title'
  )
  const contentField = event.field_history_objects?.find(
    (field) => field.field_name === 'content'
  )

  const reminderTitle = titleField?.value || ''
  const reminderContent = contentField?.value || ''

  return (
    <BaseEventCard event={event}>
      <div className="space-y-1">
        {/* User name, action, and reminder title */}
        <div className="font-inter text-base leading-[1.43] text-gray-500">
          <span className="text-gray-700 font-medium">{event.user_name}</span>{' '}
          {getActionText(event.action_type, 'reminder')}
          {reminderTitle && (
            <>
              : <span className="font-medium">{reminderTitle}</span>
            </>
          )}
        </div>

        {/* Reminder content (plain text, italic) */}
        {reminderContent && (
          <div className="font-inter text-base leading-5 italic">
            {reminderContent}
          </div>
        )}
      </div>
    </BaseEventCard>
  )
}
